import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Text } from 'foundations-components/components/Text';
import { InfoIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getUserHasGoogleSearchConsoleAccess } from '../selectors';
import { isUngatedForSiteSpeed } from '../selectors';
import useQueryParams from '../hooks/useQueryParams';
import useRouteParams from '../hooks/useRouteParams';
import { usageTracker } from '../utils/usageTracker';
import RouterSideNav from 'ui-addon-react-router-dom/RouterSideNav';
import RouterSideNavItem from 'ui-addon-react-router-dom/RouterSideNavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const trackOptimizationInteraction = action => usageTracker.track('contentOptimizationInteraction', {
  action
});
const OptimizationSidebar = ({
  contentUrl
}) => {
  const {
    url
  } = useRouteMatch();
  const {
    pageTypeSlug
  } = useRouteParams();
  const queryParams = useQueryParams();
  const queryParamsString = queryParams.toString();
  const [isDeveloperToolsPopOverOpen, setIsDeveloperToolsPopOverOpen] = useState(false);
  const userHasGoogleSearchConsoleAccess = useSelector(getUserHasGoogleSearchConsoleAccess);
  const userHasSiteSpeedAccess = useSelector(isUngatedForSiteSpeed);
  const siteSpeedUrl = `${getFullUrl('app')}/site-speed/${PortalIdParser.get()}?url=${contentUrl}&mode=URL`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(RouterSideNav, {
      "data-test-id": "optimization-sidebar",
      children: [pageTypeSlug && /*#__PURE__*/_jsx(RouterSideNavItem, {
        onOpenChange: () => trackOptimizationInteraction('seo'),
        to: {
          pathname: `${url}/seo`,
          search: queryParamsString
        },
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.optimizationTabs.recommendations"
        })
      }), userHasGoogleSearchConsoleAccess && /*#__PURE__*/_jsx(RouterSideNavItem, {
        onOpenChange: () => trackOptimizationInteraction('queries'),
        to: {
          pathname: `${url}/queries`,
          search: queryParamsString
        },
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.optimizationTabs.queries"
        })
      }), /*#__PURE__*/_jsx(RouterSideNavItem, {
        onOpenChange: () => trackOptimizationInteraction('internalLinks'),
        to: {
          pathname: `${url}/internalLinks`,
          search: queryParamsString
        },
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.optimizationTabs.internalLinks"
        })
      })]
    }), userHasSiteSpeedAccess && /*#__PURE__*/_jsxs(RouterSideNav, {
      divider: true,
      "data-test-id": "site-speed-optimization-sidebar",
      children: [/*#__PURE__*/_jsxs(TFlex, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.optimizationTabs.developerTools"
        }), /*#__PURE__*/_jsx(Popover, {
          open: isDeveloperToolsPopOverOpen,
          onOpenChange: e => setIsDeveloperToolsPopOverOpen(e.currentTarget.value),
          content: {
            header: /*#__PURE__*/_jsx(Text, {
              as: "h4",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "page-details-ui.optimizationTabs.developerToolsTooltipHeader"
              })
            }),
            body: /*#__PURE__*/_jsx(Text, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "page-details-ui.optimizationTabs.developerToolsTooltipText"
              })
            }),
            footer: /*#__PURE__*/_jsx(Link, {
              href: "https://web.dev/articles/vitals",
              external: true,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "page-details-ui.optimizationTabs.learnMore"
              })
            })
          },
          maxInlineSize: "400px",
          children: /*#__PURE__*/_jsx(Button, {
            use: "unstyled",
            onClick: () => setIsDeveloperToolsPopOverOpen(true),
            marginInlineStart: "100",
            children: /*#__PURE__*/_jsx(InfoIcon, {
              color: "do-not-use-eerie",
              size: "300"
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
        onClick: () => trackOptimizationInteraction('siteSpeed'),
        external: true,
        href: siteSpeedUrl,
        target: "_blank",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.optimizationTabs.siteSpeed"
        })
      })]
    })]
  });
};
export default OptimizationSidebar;